import axios from "axios";
import * as rdd from "react-device-detect";
import uuid from "react-uuid";
export default {
  isTokenValid: () => {
    let dateTime = Math.floor(Date.now() / 1000);
    const storedData = localStorage.getItem("userData");
    const dataStore = JSON.parse(storedData);
    if (!dataStore) {
      localStorage.clear();
      return false;
    }
    let expDate = parseInt(dataStore.expires_in) + parseInt(dataStore.time);
    return dateTime < expDate;
  },
  refreshToken: (isValid) => {
    if (!isValid) {
      axios
        .post(
          process.env.REACT_APP_API_URL + "auth/account/token/refresh",
          {},
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("tokenDataAuth"),
              "X-Requested-With": "XMLHttpRequest",
              Accept: "application/json",
              "Content-Type": "application/json",
            },
          }
        )
        .then((res) => {
          localStorage.clear();
          localStorage.setItem("tokenDataAuth", res.data.data.token);
          localStorage.setItem("userIsLoggedIn", true);
          localStorage.setItem("userData", JSON.stringify(res.data.data));
          console.log(localStorage.getItem("tokenDataAuth"));
        })
        .catch((error) => {
          localStorage.clear();
        });
    } else {
      localStorage.clear();
    }
  },
  getDeviceInfo() {
    let device = {};
    device["device_id"] = uuid();
    device["device_name"] = rdd.osName;
    device["device_serial"] = rdd.osVersion;
    device["installation_id"] = uuid();
    device["app_version_name"] = rdd.browserName;
    device["app_version_code"] = "2";
    device["device_imei"] = "0000000";
    device["device_type"] = rdd.isMobile ? "mobile" : "desktop";
    return JSON.stringify(device);
  },

  saveSession: (response) => {
    localStorage.setItem("tokenDataAuth", response.data.data.token);
    localStorage.setItem("userIsLoggedIn", true);
    localStorage.setItem("userData", JSON.stringify(response.data));
  },
  isLoggedIn: () => {
    return localStorage.getItem("userIsLoggedIn");
  },
  getToken: () => {
    return localStorage.getItem("tokenDataAuth");
  },
  getCountry: () => {
    const userData = JSON.parse(localStorage.getItem("userData"));
    if (userData) {
      return userData.data.user.country;
    } else {
      return null;
    }
  },
  logOut: () => {
    localStorage.clear();
  },
  isCorporate: () => {
    const userData = JSON.parse(localStorage.getItem("userData"));
    if (userData) {
      return userData.data.user.user_type == "corporate";
    } else {
      return false;
    }
  },
};
